export enum CouponTypeEnum {
  gameRecording = "game-recording",
  cartTotal = "cart-total",
}
